var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"cookie-comply-switch",attrs:{"title":_vm.isRequired ? 'is required' : _vm.value}},[_c('input',{attrs:{"id":"value","type":"checkbox","disabled":_vm.isRequired},domProps:{"checked":_vm.isRequired || _vm.isDefaultEnable,"value":_vm.value},on:{"input":_vm.onToggle}}),_c('span',{staticClass:"cookie-comply-slider cookie-comply-round",class:{
            'cookie-comply-required':
                _vm.isRequired,
        }})])}
var staticRenderFns = []

export { render, staticRenderFns }